export type PolicyVersionReportLinkState =
  | "no-simulation"
  | "pending"
  | "no-report"
  | "has-report";

export function resolvePolicyVersionReportLinkState(
  backtestId: string | null | undefined,
  reportIdByBacktestId: ReadonlyMap<string, string | null>,
  linksLoading: boolean
): PolicyVersionReportLinkState {
  const id = typeof backtestId === "string" ? backtestId.trim() : "";
  if (!id) return "no-simulation";
  if (!reportIdByBacktestId.has(id)) return linksLoading ? "pending" : "no-report";
  const reportId = reportIdByBacktestId.get(id);
  return reportId ? "has-report" : "no-report";
}

export function collectUniqueBacktestIds(
  backtestIds: Array<string | null | undefined>
): string[] {
  const unique = new Set<string>();
  for (const raw of backtestIds) {
    if (typeof raw !== "string") continue;
    const id = raw.trim();
    if (id) unique.add(id);
  }
  return Array.from(unique);
}
